export type NormalizedGraphQLError = {
    message: string;
    path?: string;
    errorType?: string;
    code?: string | number;
    source?: string;
};

export class GraphQLRequestError<
    TVars extends Record<string, unknown> | undefined = Record<string, unknown>,
> extends Error {
    public name = "GraphQLRequestError";
    public operationType?: string;
    public operationName?: string;
    public errorsNormalized: NormalizedGraphQLError[];
    public variablesKeys: readonly string[];
    public fingerprint?: readonly string[];
    public requestId?: string;

    constructor(params: {
        message: string;
        operationType?: string;
        operationName?: string;
        normalized: NormalizedGraphQLError[];
        variables?: TVars;
        requestId?: string;
    }) {
        super(params.message);
        this.operationType = params.operationType;
        this.operationName = params.operationName;
        this.errorsNormalized = params.normalized;
        this.variablesKeys = Object.keys(params.variables || {}).sort();
        this.requestId = params.requestId;
        const errorTypes = Array.from(
            new Set(this.errorsNormalized.map((e) => e.errorType || e.code || e.path || "unknown"))
        );
        this.fingerprint = ["graphql", this.operationName || "unknown", ...errorTypes.map(String)];
    }
}

export const extractGraphqlOperationName = (queryString: string): { type: string; name: string } | undefined => {
    const match = /\b(query|mutation|subscription)\s+(\w+)/.exec(queryString);
    return match ? { type: match[1], name: match[2] } : undefined;
};
